var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4C1 2.89543 1.89543 2 3 2H17C18.1046 2 19 2.89543 19 4V17C19 18.1046 18.1046 19 17 19H3C1.89543 19 1 18.1046 1 17V4ZM17 4H3V17H17V4Z",
    fill: "#8993A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C7.55229 1.19209e-07 8 0.447715 8 1L8 5C8 5.55229 7.55228 6 7 6C6.44771 6 6 5.55229 6 5L6 1C6 0.447715 6.44772 -1.19209e-07 7 0Z",
    fill: "#8993A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.985352 8C0.985352 7.44772 1.43307 7 1.98535 7H17.9609C18.5132 7 18.9609 7.44772 18.9609 8C18.9609 8.55229 18.5132 9 17.9609 9H1.98535C1.43307 9 0.985352 8.55228 0.985352 8Z",
    fill: "#8993A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0C13.5523 1.19209e-07 14 0.447715 14 1L14 5C14 5.55229 13.5523 6 13 6C12.4477 6 12 5.55229 12 5L12 1C12 0.447715 12.4477 -1.19209e-07 13 0Z",
    fill: "#8993A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderGrey);
export default __webpack_public_path__ + "static/media/calender-grey.5707c5ace08ea17b09f71b3452a1ea39.svg";
export { ForwardRef as ReactComponent };